module.exports = __webpack_public_path__ + "@/assets/img/Huawei.62564123.png";